import React, { useEffect } from 'react';
import { Shield, ArrowRight, ChevronRight } from 'lucide-react';
import { productData } from '../mockData';
import { Link } from 'react-router-dom';

const ProductDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="dark-page defense-page">
      {/* Product Hero */}
      <section className="defense-hero" style={{ minHeight: '70vh' }}>
        <div className="defense-hero-content" style={{ padding: '100px 0' }}>
          <div style={{ maxWidth: '1000px' }}>
            <div className="classification-badge" style={{ marginTop: '20px' }}>MILITARY GRADE</div>
            <h1 className="defense-headline" style={{ fontSize: '72px', marginTop: '24px' }}>{productData.fullName}</h1>
            <h2 className="defense-subheadline" style={{ marginTop: '20px' }}>{productData.tagline}</h2>
            <p className="defense-description" style={{ maxWidth: '800px', marginTop: '40px' }}>
              {productData.description}
            </p>
            <div className="hero-cta-group" style={{ marginTop: '60px' }}>
              <Link to="/contact" className="btn-primary-large">
                <span>Request Technical Brief</span>
                <ArrowRight size={20} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Specifications */}
      <section className="capabilities-section">
        <div className="section-tag">TECHNICAL SPECIFICATIONS</div>
        <h2 className="section-title-large">Detection & Operational Metrics</h2>
        
        <div className="capabilities-grid">
          {productData.specifications.detection.map((spec, index) => (
            <div key={index} className="capability-card">
              <div className="capability-label">{spec.label}</div>
              <div className="capability-metric" style={{ fontSize: '32px' }}>{spec.value}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Drone Configurations */}
      <section className="configs-section">
        <div className="section-tag">DRONE CONFIGURATIONS</div>
        <h2 className="section-title-large">Specialized Mission Profiles</h2>

        <div className="configs-professional">
          {productData.specifications.droneConfigs.map((config, index) => (
            <div key={index} className="config-professional">
              <div className="config-header-pro">
                <Shield size={24} className="config-icon-pro" />
                <h3 className="config-title-pro">{config.type}</h3>
              </div>
              <div className="config-metrics">
                <div className="metric-item">
                  <span className="metric-label-pro">Max Speed</span>
                  <span className="metric-value-pro">{config.speed}</span>
                </div>
                <div className="metric-item">
                  <span className="metric-label-pro">Range</span>
                  <span className="metric-value-pro">{config.range}</span>
                </div>
                <div className="metric-item">
                  <span className="metric-label-pro">Flight Time</span>
                  <span className="metric-value-pro">{config.flightTime}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Features */}
      <section className="capabilities-section" style={{ background: '#0A0A0A' }}>
        <div className="section-tag">CORE CAPABILITIES</div>
        <h2 className="section-title-large">Advanced Features</h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '40px', maxWidth: '1400px', margin: '0 auto' }}>
          {productData.features.map((feature, index) => (
            <div key={index} style={{ padding: '40px', background: '#000000', border: '1px solid rgba(212, 175, 55, 0.2)' }}>
              <h3 className="capability-label" style={{ fontSize: '18px', marginBottom: '16px' }}>{feature.title}</h3>
              <p className="capability-desc">{feature.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Competitive Comparison */}
      <section className="capabilities-section" style={{ background: '#000000' }}>
        <div className="section-tag">COMPETITIVE ANALYSIS</div>
        <h2 className="section-title-large">Wolf Eye vs. Market Leaders</h2>
        
        <div style={{ maxWidth: '1400px', margin: '60px auto 0', overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '2px', background: 'rgba(212, 175, 55, 0.1)' }}>
            <thead>
              <tr>
                <th style={{ padding: '20px', background: '#0A0A0A', color: '#D4AF37', fontSize: '14px', fontWeight: '700', textAlign: 'left', textTransform: 'uppercase', letterSpacing: '1px' }}>Specification</th>
                <th style={{ padding: '20px', background: 'rgba(212, 175, 55, 0.2)', color: '#D4AF37', fontSize: '14px', fontWeight: '700', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '1px' }}>Wolf Eye<br/><span style={{ fontSize: '11px', opacity: 0.7 }}>Labana Dynamics</span></th>
                <th style={{ padding: '20px', background: '#0A0A0A', color: '#FFFFFF', fontSize: '14px', fontWeight: '700', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '1px' }}>DJI Aeroscope<br/><span style={{ fontSize: '11px', opacity: 0.5 }}>Detection Only</span></th>
                <th style={{ padding: '20px', background: '#0A0A0A', color: '#FFFFFF', fontSize: '14px', fontWeight: '700', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '1px' }}>DroneShield<br/><span style={{ fontSize: '11px', opacity: 0.5 }}>Australia</span></th>
                <th style={{ padding: '20px', background: '#0A0A0A', color: '#FFFFFF', fontSize: '14px', fontWeight: '700', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '1px' }}>Dedrone<br/><span style={{ fontSize: '11px', opacity: 0.5 }}>USA</span></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px' }}>Price per Module</td>
                <td style={{ padding: '16px 20px', background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37', fontSize: '18px', fontWeight: '700', textAlign: 'center' }}>€90K</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>€150K</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>€120K</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>€180K</td>
              </tr>
              <tr>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px' }}>Response Time</td>
                <td style={{ padding: '16px 20px', background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37', fontSize: '18px', fontWeight: '700', textAlign: 'center' }}>{'<'}3 sec</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.5)', fontSize: '16px', textAlign: 'center' }}>N/A</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>4-6 sec</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>6-10 sec</td>
              </tr>
              <tr>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px' }}>Interception Rate</td>
                <td style={{ padding: '16px 20px', background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37', fontSize: '18px', fontWeight: '700', textAlign: 'center' }}>98.7%</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.5)', fontSize: '16px', textAlign: 'center' }}>Detection Only</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>92%</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>89%</td>
              </tr>
              <tr>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px' }}>Max Range</td>
                <td style={{ padding: '16px 20px', background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37', fontSize: '18px', fontWeight: '700', textAlign: 'center' }}>5+ km</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>5 km</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>3 km</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>4 km</td>
              </tr>
              <tr>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px' }}>Autonomous Operation</td>
                <td style={{ padding: '16px 20px', background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37', fontSize: '18px', fontWeight: '700', textAlign: 'center' }}>✓ Full</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.5)', fontSize: '16px', textAlign: 'center' }}>Manual</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>Semi-Auto</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>Semi-Auto</td>
              </tr>
              <tr>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px' }}>Modular Payloads</td>
                <td style={{ padding: '16px 20px', background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37', fontSize: '18px', fontWeight: '700', textAlign: 'center' }}>✓ 3 Types</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.5)', fontSize: '16px', textAlign: 'center' }}>–</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>Fixed</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>Fixed</td>
              </tr>
              <tr>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px' }}>Deployment Time</td>
                <td style={{ padding: '16px 20px', background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37', fontSize: '18px', fontWeight: '700', textAlign: 'center' }}>{'<'}30 min</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>2-4 hrs</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>1-2 hrs</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>2-3 hrs</td>
              </tr>
              <tr>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '14px' }}>NATO Certified</td>
                <td style={{ padding: '16px 20px', background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37', fontSize: '18px', fontWeight: '700', textAlign: 'center' }}>✓ Yes</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>No</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>Pending</td>
                <td style={{ padding: '16px 20px', background: '#0A0A0A', color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', textAlign: 'center' }}>Yes</td>
              </tr>
            </tbody>
          </table>
          <p style={{ fontSize: '12px', color: '#666666', marginTop: '24px', textAlign: 'center' }}>* Competitive data as of December 2024. Specifications subject to change.</p>
        </div>
      </section>

      {/* Certifications */}
      <section className="capabilities-section">
        <div className="section-tag">CERTIFICATIONS & COMPLIANCE</div>
        <h2 className="section-title-large">Standards & Validation</h2>
        
        <div className="capabilities-grid">
          {productData.certifications.map((cert, index) => (
            <div key={index} className="capability-card">
              <div className="capability-label">{cert.name}</div>
              <p className="capability-desc" style={{ marginTop: '12px' }}>{cert.description}</p>
              <div style={{ marginTop: '16px', padding: '6px 12px', background: 'rgba(212, 175, 55, 0.1)', color: '#D4AF37', fontSize: '11px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', width: 'fit-content' }}>
                {cert.status}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="final-cta-section">
        <div className="final-cta-content">
          <h2 className="cta-headline">Request Deployment Brief</h2>
          <p className="cta-subtext">
            Contact our team for detailed specifications and procurement information.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn-primary-large">
              <span>Request Quote</span>
              <ChevronRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProductDetails;
